<section id="features" class="features-section">
  <!-- Split header: title on left, supporting copy on right -->
  <div class="features-head reusable-container">
    <div class="features-head-left">
      <div class="features-eyebrow">
        <span class="dot"></span>
        Why institutions choose us
      </div>
      <h2 class="features-title">
        Built for the way <span class="accent">Tanzania works.</span>
      </h2>
    </div>
    <div class="features-head-right">
      <p class="features-sub">
        Six capabilities, one platform. No bolt-ons. No per-feature licensing —
        just the tools your institution needs to meet, decide, and deliver.
      </p>
      <div class="features-head-meta">
        <span class="meta-pill"><mat-icon>verified</mat-icon> e-GA certified</span>
        <span class="meta-pill"><mat-icon>shield</mat-icon> Sovereign hosting</span>
      </div>
    </div>
  </div>

  <!-- Tilted card rail -->
  <div class="features-rail reusable-container">
    @for (feature of features; track $index) {
      <article class="tilt-card"
               [class.tilt-up]="$index % 2 === 0"
               [class.tilt-down]="$index % 2 === 1">
        <span class="tilt-num">{{ ($index + 1).toString().padStart(2, '0') }}</span>
        <div class="tilt-icon">
          <img [src]="feature.icon" alt="" />
        </div>
        <h3 class="tilt-title">{{ feature.title }}</h3>
        <p class="tilt-desc">{{ feature.description }}</p>
      </article>
    }
  </div>
</section>
